import { StateService } from "@uirouter/angularjs";

export class ProgressiveDefinitionDetailViewController {
  static $inject = ["progressiveDefinition", "$state", "progressiveReport"];

  reportUrl: string = "";

  constructor(
    readonly progressiveDefinition: any,
    private readonly $state: StateService,
    readonly progressiveReport: any
  ) {
    this.reportUrl = `/api/machines/progressives/reports/${progressiveReport.JsReportId}?ProgressiveDefinitionId=${progressiveDefinition.Id}`;
  }

  clone() {
    this.$state.go("main.machines.progressives.progressiveDefinitions.add", {
      progressiveDefinition: this.progressiveDefinition,
    });
  }
}
